import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../../shared/store';
import {
  AnalyticsCourse,
  CourseActivityOverview,
  CourseAggregateMetrics,
  CourseGrade,
  StudentCourseMetrics,
} from '../models/analytics.model';

export const ANALYTICS_DATA_SERVICE = new InjectionToken<AnalyticsDataService>('[MyHub] AnalyticsDataService');

export interface AnalyticsDataService {
  getCourses(): ObservableResult<AnalyticsCourse[]>;

  getCourseGrades(courseId: number): ObservableResult<CourseGrade[]>;

  getCourseMetrics(courseId: number): ObservableResult<CourseAggregateMetrics>;

  getCourseActivityOverview(courseId: number): ObservableResult<CourseActivityOverview>;

  getMyMetrics(courseId: number): ObservableResult<StudentCourseMetrics>;
}
